import { Component, EventEmitter, HostListener, inject, Input, OnInit, Output, signal } from '@angular/core';
import { VideoCreatorResponseDto, VideoResponseDto } from '../../common/general-types/videos.dto';
import { VideoService } from '../../services/video/video.service';
import { SuperSocialService } from '../../services/super-social/super-social.service';
import { FormatService } from '../../common/format/format.service';
import { MgcPortfolioInlineVideoComponent } from '../../pages/creators/molecules/creator-profile/mgc-portfolio/mgc-portfolio-inline-video.component';
import { Router } from '@angular/router';
import { ViewportOverlayDirective } from '../../common/directives/viewport-overlay/viewport-overlay.directive';

@Component({
  selector: 'atom-single-video-viewer-summary',
  standalone: true,
  imports: [MgcPortfolioInlineVideoComponent],
  hostDirectives: [ViewportOverlayDirective],
  templateUrl: './single-video-viewer-summary.component.html',
  styleUrl: './single-video-viewer-summary.component.css'
})
export class SingleVideoViewerSummaryComponent implements OnInit {

  @Input() video!: VideoCreatorResponseDto | VideoResponseDto;
  @Input() showFooter: boolean = false;  
  @Output() closePreviewOut = new EventEmitter<void>();


  isPlaying = signal<boolean>(false);
  audio = new Audio();

  summary = signal<{
    content_summary: any;
    platform: string;
    post: any;
    video_file: any;
  } | undefined>(undefined);

  /** Services */
  private superSocialService = inject(SuperSocialService);
  public formatService = inject(FormatService);
  public videoService = inject(VideoService);
  private router = inject(Router);
  /**Services END */

  @HostListener('document:keydown.escape', ['$event' as any])
  handleEscapeKey(event: KeyboardEvent) {
    this.closeSingleVideoViewerSummary();
  }


  ngOnInit(): void {
    this.getContentSummary();
  }

  getContentSummary() {
    if (this.video) {
      this.superSocialService.getContentSumaryByFullUrl(this.video.fullUrl).subscribe((res) => {
        console.log('Content Summary: ', res);
        this.summary.set(res);
      });
    }
  }

  togglePlayPause() {
    if (!this.isPlaying() && this.summary()?.video_file?.musicInfo) {
      this.audio.src = this.summary()?.video_file?.musicInfo.music;
      this.audio.load();
      this.audio.play();
      this.isPlaying.set(true);

      // When audio ends, reset play status
      this.audio.onended = () => {
        this.isPlaying.set(false);
      };
    } else {
      this.audio.pause();
      this.isPlaying.set(false);
    }
  } 

  goToBrief() {
    console.log('goToBrief: ', this.video);
    if (this.video) {
      this.router.navigate(['/manage-brief', this.video.briefId, '1']);
    }
  }
  
  viewSubmission() {
    console.log('viewSubmission: ', this.video);
    if (this.video) {
      this.router.navigate(['/view-submission', this.video.briefId, this.video.creatorId]);
    }
  }

  closeSingleVideoViewerSummary() {
    this.closePreviewOut.emit();
  }
}
